const $ = jQuery;

const CartUpdate = {
  init: function () {
    this.setupEventListeners();
  },

  setupEventListeners: function () {
    this.setupCartQuantityChange();
    this.setupFormSubmit();
    this.replaceCartFormIfNeeded();
  },

  setupCartQuantityChange: function () {
    $(document).on(
      "input change",
      '.woocommerce-cart-form :input[name^="cart["][name$="][qty]"]',
      () => {
        $('[name="update_cart"]').prop("disabled", false);
      }
    );
  },

  setupFormSubmit: function () {
    $(".woocommerce-cart-form").on("submit", (e) => {
      if ($('[name="update_cart"]').prop("disabled") === false) {
        return true; 
      } else {
        e.preventDefault(); 
      }
    });
  },

  replaceCartFormIfNeeded: function () {
    const $new_form = $("#new_cart_form");

    if ($new_form.length) {
      $(".woocommerce-cart-form").replaceWith($new_form);
      $new_form.find(':input[name="update_cart"]').prop("disabled", true);
      this.setupEventListeners(); 
    }
  },
};

export default CartUpdate;
